<div class="fx-admin-bonus">
    <div class="row">
        <div class="col">
            <fx-page-header [title]="'Permanent bonus'"></fx-page-header>
        </div>
    </div>
    <div class="card bg-dark-lighter text-white">
        <div class="card-body">
            <fx-tab [tabs]="tabs" [activeTab]="tabSelect" (selected)="onChangeTab($event)">
            </fx-tab>
            <ng-container *ngIf="tabSelect == tabs[0]">
                <div class="row">
                    <div class="col">
                        <fx-bonus-common-setting [permission]="permission" [type]="type">
                        </fx-bonus-common-setting>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col">
                        <fx-bonus-history></fx-bonus-history>
                    </div>
                </div> -->
            </ng-container>
            <ng-container *ngIf="tabSelect == tabs[1]">
              <fx-bonus-common-setting [permission]="permission" type="permanent_bonus_ib"></fx-bonus-common-setting>
                <!-- <div class="row">
                    <div class="col">
                        <fx-bonus-setting [permission]="permission"
                            (onUpdateHistory)="onLoadCodeHistory($event)"></fx-bonus-setting>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <fx-bonus-code-history [loadData]="onLoadCodeData">
                        </fx-bonus-code-history>
                    </div>
                </div> -->
              <!--<app-ib-bonus></app-ib-bonus>-->
            </ng-container>
        </div>
    </div>
    <!-- <ng-container *ngIf="tabSelect == tabs[0]">
      <div class="row">
        <div class="col">
          <fx-bonus-common-setting [permission]="permission">
          </fx-bonus-common-setting>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <fx-bonus-history></fx-bonus-history>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="tabSelect == tabs[1]">
      <div class="row">
        <div class="col">
          <fx-bonus-setting [permission]="permission" (onUpdateHistory)="onLoadCodeHistory($event)"></fx-bonus-setting>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <fx-bonus-code-history [loadData]="onLoadCodeData">
          </fx-bonus-code-history>
        </div>
      </div>
    </ng-container> -->
</div>
